import React, { Fragment, useState } from 'react'
import * as S from './style'
import Svg from '@components/svg'
import { plus, wallet } from '@assets/icons'

import { Form, Formik } from 'formik'
import Fields from '@components/fields'
import Column from '@components/column'
import styled from '@emotion/styled'
import Button from '@components/button'
import { useModal } from '@context/ModalContext'
import transaction from '@apis/transaction'
import { Helper } from '@utils/index'

export const Profile = ({ user }: any) => {
  const { showModal } = useModal()
  const adminData = Helper.getUser()
  console.log(typeof adminData.infos, 'type of infos', adminData)
  const getValue = (value: any) => {
    return value ?? 'N/A'
  }

  const statCardData = [
    {
      icon: wallet,
      title: 'Total Won Points',
      amount: `Rs. ${getValue(user?.totalWonPoints)}`,
    },
    {
      icon: wallet,
      title: 'Total Matchroom Created',
      amount: `${getValue(user?.totalMatchCreated)}`,
    },
    {
      icon: wallet,
      title: 'Total Load Amount',
      amount: `${getValue(user?.totalLoadWallet)}`,
    },
    {
      icon: wallet,
      title: 'Total Points',
      amount: `Rs. ${getValue(user?.points)}`,
    },
    {
      icon: wallet,
      title: 'Total Matchroom Joined',
      amount: `${getValue(user?.totalMatchJoin)}`,
    },
    {
      icon: wallet,
      title: 'Total Withdrawal',
      amount: `${getValue(user?.totalWithdraw)}`,
    },
  ]

  return (
    <>
      <S.StyleUserDetailWrapper>
        <S.StyleProfileWrapper>
          <S.PersonalInfo>
            <S.ProfileWrapper>
              {user?.avatar ? (
                <S.Profile src={`https://admin.tournaop.com/${user.avatar}`} />
              ) : (
                <S.ProfileFallback>
                  {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                </S.ProfileFallback>
              )}
            </S.ProfileWrapper>

            <S.Details>
              <S.Name>{getValue(user?.name)}</S.Name>
              <S.Number>{getValue(user?.phoneNo)}</S.Number>
              <S.Email>{getValue(user?.email)}</S.Email>
            </S.Details>
          </S.PersonalInfo>
          {/* here if adminData.ingos is null that measn he is super admin so he will see the Load Wallet button alwasy */}

          {(adminData?.infos === null ||
            !!adminData?.infos?.allowLoadWallet) && (
            <S.ActionButton
              onClick={() => showModal(<LoadWallet number={user?.phoneNo} />)}
            >
              <Svg src={plus} styleSvg={S.translateSvg} />
              Load Wallet
            </S.ActionButton>
          )}
        </S.StyleProfileWrapper>

        {statCardData.map((item, i) => (
          <S.StyleStatsCard key={i}>
            <S.StyleStatsCardTitleWrapper>
              <Svg src={item.icon} styleSvg={S.translateSvg} />
              <S.StyleStatsCardTitle>{item.title}</S.StyleStatsCardTitle>
            </S.StyleStatsCardTitleWrapper>
            <S.StyleStatsCardNumber>{item.amount}</S.StyleStatsCardNumber>
          </S.StyleStatsCard>
        ))}
      </S.StyleUserDetailWrapper>
    </>
  )
}

export const LoadWallet = ({ number }: any) => {
  const { hideModal } = useModal()
  const [initialValues, setInitialValues] = useState({
    phoneNumber: number,
    loadAmount: '',
    walletType: 'points',
  })
  const handleSubmit = async (values) => {
    try {
      const payload = {
        phoneNo: values.phoneNumber,
        amount: parseInt(values.loadAmount),
        paymentMethod: 'admin',
        walletType: values.walletType,
      }
      await transaction.loadwallet({ state: 'transactions', data: payload })
      hideModal()
    } catch (error) {}
  }
  return (
    <Fragment>
      <Column>
        <ModalTitle>Load User Wallet</ModalTitle>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          <Form>
            <Column>
              <Fields.PhoneInput
                name="phoneNumber"
                placeholder="Enter Mobile Number"
                label="Mobile Number"
              />
              <Fields.DropDown
                label="Wallet Type"
                name="walletType"
                placeholder="Select Wallet Type"
                valueAsKey="key"
                titleAsKey="title"
                styleWrapper="z-index:99999998"
                options={[
                  { title: 'Main Wallet (Points)', key: 'points' },
                  {
                    title: 'Store Wallet (Store Points)',
                    key: 'storePoints',
                  },
                ]}
                styleInput="width:96%"
              />
              <Fields.Input
                name="loadAmount"
                placeholder="Enter Amount "
                label="Load Amount"
              />

              <Button title="Submit" type="submit" width={100} height={45} />
            </Column>
          </Form>
        </Formik>
      </Column>
    </Fragment>
  )
}

const ModalTitle = styled.p`
  color: ${(props: any) => props.theme.colors.primary};
  font-size: 20px;
  text-align: center;
`
